import React from "react";
import { Alert, Button, Modal } from "antd";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import AppLayout from "../components/Layout";
import ScenarioCard, { TileGrid } from "../components/ScenarioCard";
import ContactForm from "../components/ContactForm";
import httpClient from "../axios";
import { notifyError, notifySuccess, SCENARIOS } from "../helper";

/** Event mode: pick the scenario, then enter the contact's details. */
const AddEventContact = () => {
	const [params] = useSearchParams();
	const navigate = useNavigate();
	const http = React.useMemo(() => httpClient(), []);
	const eventId = params.get("id");
	const eventName = params.get("name");
	const [scenario, setScenario] = React.useState(null);
	const [loading, setLoading] = React.useState(false);

	const onSubmit = (values) => {
		setLoading(true);
		http
			.post("/students", {
				name: values.name.trim(),
				email: values.email.trim(),
				phone_number: values.phone_number || null,
				event_type: scenario.key,
				event_id: eventId,
			})
			.then(() => {
				notifySuccess("Contact added to the event");
				setScenario(null);
				navigate(`/events/${eventId}/students`);
			})
			.catch((error) => notifyError(error, "Could not add the contact"))
			.finally(() => setLoading(false));
	};

	return (
		<AppLayout
			title={eventName ? `Add contact to ${eventName}` : "Add contact to event"}
			subtitle="Select the scenario this contact will complete, then enter their details."
		>
			<Link to="/events" style={{ display: "inline-block", marginBottom: 16 }}>
				<ArrowLeftOutlined /> All events
			</Link>
			{!eventId && (
				<Alert type="warning" showIcon style={{ marginBottom: 24 }} message="No event selected" description="Open this page from the Events list." />
			)}
			<TileGrid>
				{SCENARIOS.map((s) => (
					<ScenarioCard key={s.key} icon={s.icon} title={s.title} onClick={() => eventId && setScenario(s)} />
				))}
			</TileGrid>

			<Modal
				title={scenario ? `New contact — ${scenario.title}` : "New contact"}
				visible={Boolean(scenario)}
				onCancel={() => setScenario(null)}
				footer={null}
				destroyOnClose
			>
				<ContactForm
					onSubmit={onSubmit}
					loading={loading}
					submitLabel="Add contact"
					extra={<Button onClick={() => setScenario(null)}>Cancel</Button>}
				/>
			</Modal>
		</AppLayout>
	);
};

export default AddEventContact;
